// extracted by mini-css-extract-plugin
export var orderDetails = "_pl-2";
export var orderImage = "_pl-1";
export var orderMeta = "_pl-3";
export var orderSummary = "_pl-0";
export var rightArrow = "_pl-4";